import { ReactNode } from "react";
import { FilePreviewKind, getFilePreviewKind } from "@/utils/file-preview";

export interface PreviewFile {
  name: string;
  url: string;
}

interface FileViewerProps {
  file: PreviewFile;
  zoom?: number;
  className?: string;
  /** Conteúdo exibido quando o tipo do arquivo não é visualizável (ex.: placeholder/upload). */
  fallback?: ReactNode;
}

interface ViewerContext {
  file: PreviewFile;
  className: string;
  style: React.CSSProperties;
  fallback?: ReactNode;
}

const VIEWERS: Record<FilePreviewKind, (ctx: ViewerContext) => ReactNode> = {
  pdf: ({ file, className, style }) => (
    <iframe
      src={`${file.url}#toolbar=0&view=FitH`}
      className={className}
      style={style}
      title={file.name}
    />
  ),
  image: ({ file, className, style }) => (
    <img src={file.url} className={className} style={style} alt={file.name} />
  ),
  office: ({ file, className, style }) => (
    <iframe
      src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        file.url,
      )}`}
      className={className}
      style={style}
      title={file.name}
    />
  ),
  unknown: ({ fallback }) => <>{fallback ?? null}</>,
};

export const FileViewer = ({
  file,
  zoom = 1,
  className = "w-full h-full",
  fallback,
}: FileViewerProps) => {
  const kind = getFilePreviewKind(file.name);
  const style: React.CSSProperties = {
    transform: `scale(${zoom})`,
    transformOrigin: "top left",
  };

  return <>{VIEWERS[kind]({ file, className, style, fallback })}</>;
};
